import React, { useState } from 'react';
import { Avatar, Box, Button, Tooltip, Typography } from "@mui/joy";

import '../styles/sidemenu.scss';

import { BubbleChart, ChevronRight, Dashboard, GraphicEqTwoTone, List, Settings, Topic, BarChart } from '@mui/icons-material';

const helper = require('../Helpers/helpers');

function SideMenu({ plan, handler, app }: any) {
    const [collapsed, setCollapsed] = useState(true);
    const [activeIndex, setActiveIndex] = useState(0);

    const itemTapped = (index: any) => {
        setActiveIndex(index);

        handler(index);
    }

    const stores = () => {
        const availableStores = [
            app.app.appleappid && 'applestore',
            app.app.androidpackageid && 'playstore',
            app.app.app_gallery_id && 'appgallery'
        ].filter(Boolean);

        if (!availableStores.length) return null;

        return (
            <span className="mr-3">
                {availableStores.map((store, index) => (
                    <span key={store}>
                        {index > 0 && <span> + </span>}
                        {helper.iconFor(store, 18)}
                    </span>
                ))}
            </span>
        );
    };

    return (
        <Box sx={{
            display: "flex",
            height: "100vh",
        }}>
            <Box
                sx={{
                    width: collapsed ? "60px" : "250px",
                    transition: "width 0.3s ease-in-out",
                    color: "#313131",
                    display: "flex",
                    flexDirection: "column",
                    paddingTop: "10px"
                }}
            >
                {/* <Button
                    variant="plain"
                    onClick={() => setCollapsed(!collapsed)}
                    sx={{
                        color: "#313131",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        marginBottom: "10px"
                    }}
                >
                    {collapsed ? <ChevronRight /> : <ChevronLeft />}
                </Button> */}
                <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    <Tooltip
                        title='Dashboard'
                        placement='right'>
                        <Button
                            key={0}
                            variant="plain"
                            sx={{
                                display: "flex",
                                justifyContent: collapsed ? "center" : "flex-start",
                                backgroundColor: activeIndex === 0 ? "#f5f5f5" : "white",
                                color: "#313131",
                                gap: "10px",
                                width: "100%",
                                padding: "10px 15px"
                            }}
                            onClick={() => itemTapped(0)}
                        >
                            <Dashboard /> {!collapsed && "Dashboard"}
                        </Button>
                    </Tooltip>
                    <Tooltip
                        title='Ratings'
                        placement='right'>
                        <Button
                            key={1}
                            variant="plain"
                            sx={{
                                display: "flex",
                                justifyContent: collapsed ? "center" : "flex-start",
                                color: "#313131",
                                backgroundColor: activeIndex === 1 ? "#f5f5f5" : "white",
                                gap: "10px",
                                width: "100%",
                                padding: "10px 15px"
                            }}
                            onClick={() => itemTapped(13)}
                        >
                            <BarChart /> {!collapsed && "Ratings"}
                        </Button>
                    </Tooltip>
                    <Tooltip
                        title='Reviews'
                        placement='right'>
                        <Button
                            key={1}
                            variant="plain"
                            sx={{
                                display: "flex",
                                justifyContent: collapsed ? "center" : "flex-start",
                                color: "#313131",
                                backgroundColor: activeIndex === 1 ? "#f5f5f5" : "white",
                                gap: "10px",
                                width: "100%",
                                padding: "10px 15px"
                            }}
                            onClick={() => itemTapped(1)}
                        >
                            <List /> {!collapsed && "Reviews"}
                        </Button>
                    </Tooltip>
                    <Tooltip
                        title='Heartbeat'
                        placement='right'>
                        <Button
                            key={2}
                            variant="plain"
                            sx={{
                                display: "flex",
                                justifyContent: collapsed ? "center" : "flex-start",
                                color: "#313131",
                                backgroundColor: activeIndex === 2 ? "#f5f5f5" : "white",
                                gap: "10px",
                                width: "100%",
                                padding: "10px 15px"
                            }}
                            onClick={() => itemTapped(2)}
                        >
                            <GraphicEqTwoTone /> {!collapsed && "Heartbeat"}
                        </Button>
                    </Tooltip>
                    <Tooltip
                        title='Topics & Words'
                        placement='right'>
                        <Button
                            key={3}
                            variant="plain"
                            sx={{
                                display: "flex",
                                justifyContent: collapsed ? "center" : "flex-start",
                                backgroundColor: activeIndex === 3 ? "#f5f5f5" : "white",
                                color: "#313131",
                                gap: "10px",
                                width: "100%",
                                padding: "10px 15px"
                            }}
                            onClick={() => itemTapped(3)}
                        >
                            <Topic /> {!collapsed && "Topics & Words"}
                        </Button>
                    </Tooltip>
                    {plan === 'U' &&
                        <Tooltip
                            title='Proactive feedback'
                            placement='right'>
                            <Button
                                key={8}
                                variant="plain"
                                sx={{
                                    display: "flex",
                                    justifyContent: collapsed ? "center" : "flex-start",
                                    backgroundColor: activeIndex === 8 ? "#f5f5f5" : "white",
                                    color: "#313131",
                                    gap: "10px",
                                    width: "100%",
                                    padding: "10px 15px"
                                }}
                                onClick={() => itemTapped(8)}
                            >
                                <BubbleChart /> {!collapsed && "Proactive feedback"}
                            </Button>
                        </Tooltip>
                    }
                    {/* <Tooltip
                        title='Benchmark'
                        placement='right'>
                        <Button
                            key={12}
                            variant="plain"
                            sx={{
                                display: "flex",
                                justifyContent: collapsed ? "center" : "flex-start",
                                backgroundColor: activeIndex === 12 ? "#f5f5f5" : "white",
                                color: "#313131",
                                gap: "10px",
                                width: "100%",
                                padding: "10px 15px"
                            }}
                            onClick={() => itemTapped(12)}
                        >
                            <Compare /> {!collapsed && "Benchmark"}
                        </Button>
                    </Tooltip> */}
                    <Tooltip
                        title='App settings'
                        placement='right'>
                        <Button
                            key={9}
                            variant="plain"
                            sx={{
                                display: "flex",
                                justifyContent: collapsed ? "center" : "flex-start",
                                backgroundColor: activeIndex === 9 ? "#f5f5f5" : "white",
                                color: "#313131",
                                gap: "10px",
                                width: "100%",
                                padding: "10px 15px"
                            }}
                            onClick={() => itemTapped(9)}
                        >
                            <Settings /> {!collapsed && "Settings"}
                        </Button>
                    </Tooltip>
                    <Tooltip
                        title='Change app'
                        placement='right'>
                        <Button
                            key={9}
                            variant="plain"
                            sx={{
                                marginTop: 4,
                                paddingTop: 2,
                                paddingBottom: 2,
                                textAlign: "left",
                                color: "#313131"
                            }}
                            onClick={() => itemTapped(11)}
                        >
                            <div className='row'>
                                <div
                                    className={collapsed
                                        ? 'col-auto my-auto mx-auto'
                                        : 'col-auto my-auto ms-2'
                                    }>
                                    <Avatar
                                        alt={app.name + 'App icon'}
                                        src={app.icon}
                                        size='lg'>
                                        {helper.getInitials(app.name)}
                                    </Avatar>
                                </div>
                                {!collapsed &&
                                    <>
                                        <div
                                            className='col my-auto'>
                                            <Typography
                                                level='title-sm'>
                                                {app.name}
                                            </Typography>
                                            <Typography
                                                level='body-xs'>
                                                {app.country} | {stores()}
                                            </Typography>
                                        </div>
                                        <div className='col-auto my-auto'>
                                            <ChevronRight />
                                        </div>
                                    </>
                                }
                            </div>
                        </Button>
                    </Tooltip>
                </Box>
            </Box>
        </Box>
    );
}

export default SideMenu;